// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "table[data-v-41670d05]{border-collapse:collapse}table[data-v-41670d05],td[data-v-41670d05],th[data-v-41670d05]{border:.5px solid #000}thead[data-v-41670d05]{display:table-row-group}tr td[data-v-41670d05]{page-break-inside:avoid}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
